import {prepareDestinationsApiRequest} from '../utils/prepareDestinationsApiRequest';
import {xhrHelper} from './../../../utils/xhrHelper';
import {AppState} from './../../../store';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {toggleLoadingDestinationsAction, updateDestinationsAction} from './actions';
import {IDestinationsStoreState} from './types';

export const fetchDestinationsThunk = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingDestinationsAction(true));
    const url = prepareDestinationsApiRequest();
    xhrHelper<{}, {success: boolean; data: IDestinationsStoreState['data']}>({
      name: 'destinations api',
      type: 'GET',
      url,
    })
      .then(response => {
        dispatch(
          updateDestinationsAction(
            (response.data.success
              ? {...response.data.data}
              : null) as IDestinationsStoreState['data'],
          ),
        );
        dispatch(toggleLoadingDestinationsAction(false));
      })
      .catch(err => {
        dispatch(toggleLoadingDestinationsAction(false));
        // ! do something for error case
      });
  };
};
